import type { SearchQuestionsQuery } from '@exam-management/graphql';
import { Flex, InfiniteScroll, Loading } from '@shared/components';

import { NoQuestionInLocationOverlay } from '../no-question-in-location-overlay';
import { SingleQuestionInLocation } from '../single-question-in-location';

type Questions = SearchQuestionsQuery['qctSearchQuestions']['questions'];

export interface QuestionInLocationListProps {
  questions: Questions;
  loading: boolean;
  hasMore: boolean;
  handleFetchMore: () => Promise<void>;
  currentPage: number;
  currentQuestionId?: string;
}

export default function QuestionInLocationList(props: Readonly<QuestionInLocationListProps>) {
  const {
    questions,
    loading: isLoading,
    hasMore,
    handleFetchMore: fetchMore,
    currentPage,
    currentQuestionId,
  } = props;

  const handleFetchMore = async () => {
    await fetchMore();
  };

  if (isLoading && !questions.length) {
    return <Loading />;
  }

  if (!questions.length) {
    return <NoQuestionInLocationOverlay variant='no-question' />;
  }

  return (
    <InfiniteScroll
      hasMore={hasMore}
      handleFetch={handleFetchMore}
      loading={isLoading}
      loader={<Loading />}
      maxHeight={currentPage === 0 && !hasMore ? 'fit-content' : '384px'}
    >
      <Flex sx={(theme) => ({ flexDirection: 'column', rowGap: theme.spacing(2.5) })}>
        {questions.map((question) => (
          <SingleQuestionInLocation
            question={question}
            key={question.id}
            highlight={question.id === currentQuestionId}
          />
        ))}
      </Flex>
    </InfiniteScroll>
  );
}
